import React, { useEffect, useState } from "react";
import { Card, Form, Button, Alert, Row, Col, Spinner, Badge } from "@themesberg/react-bootstrap";
import api from "../../utils/api";

const emptyConfig = {
  enabled: false,
  baseUrl: "http://127.0.0.1:11434",
  model: "qwen2.5:32b",
  delaySeconds: 4,
  rules: []
};

export default function AiTraining() {
  const [config, setConfig] = useState(emptyConfig);
  const [draft, setDraft] = useState("");
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const [name, setName] = useState("Zeynep");
  const [age, setAge] = useState("39");
  const [manCity, setManCity] = useState("İstanbul");
  const [chat, setChat] = useState([]);
  const [text, setText] = useState("");
  const [asking, setAsking] = useState(false);

  useEffect(() => {
    let gone = false;
    api.get("/ai/training")
      .then((res) => { if (!gone) setConfig({ ...emptyConfig, ...res.data }); })
      .catch((err) => { if (!gone) setError(err.response?.data?.error || err.message); })
      .finally(() => { if (!gone) setLoading(false); });
    return () => { gone = true; };
  }, []);

  const save = async (next) => {
    setSaving(true);
    setError(null);
    setSuccess(null);
    try {
      const res = await api.put("/ai/training", next);
      setConfig({ ...emptyConfig, ...res.data });
      setSuccess("Kaydedildi. Bir sonraki mesaj bu komutları kullanır.");
    } catch (err) {
      setError(err.response?.data?.error || err.message);
    } finally {
      setSaving(false);
    }
  };

  const addRule = () => {
    const value = draft.trim();
    if (!value) return;
    const rules = [...config.rules, { id: `k${Date.now()}`, text: value, active: true }];
    setDraft("");
    save({ ...config, rules });
  };

  const updateRule = (id, patch) => {
    const rules = config.rules.map((rule) => (rule.id === id ? { ...rule, ...patch } : rule));
    setConfig({ ...config, rules });
  };

  const removeRule = (id) => {
    save({ ...config, rules: config.rules.filter((rule) => rule.id !== id) });
  };

  const sendTest = async () => {
    const value = text.trim();
    if (!value || asking) return;
    const history = chat.map((item) => ({ role: item.role, content: item.content }));
    setChat((prev) => [...prev, { role: "user", content: value }]);
    setText("");
    setAsking(true);
    setError(null);
    try {
      const res = await api.post("/ai/test", { text: value, history, name, age, manCity });
      setChat((prev) => [...prev, { role: "assistant", content: res.data.reply }]);
    } catch (err) {
      setError(err.response?.data?.error || err.message);
    } finally {
      setAsking(false);
    }
  };

  if (loading) {
    return <div className="p-4"><Spinner animation="border" /></div>;
  }

  return (
    <div className="p-3">
      <h4 className="mb-3">AI eğitim seti</h4>
      <p className="text-muted">
        Buraya yazdığın komut, modelin bir sonraki cevabında açılış metni olur. Ağırlıklar değişmez.
        Uygulama içindeki sohbet, anahtar açıkken aynı komutları kullanır.
      </p>
      {error && <Alert variant="danger">{error}</Alert>}
      {success && <Alert variant="success">{success}</Alert>}

      <Card className="mb-3">
        <Card.Body>
          <Row className="g-3 align-items-end">
            <Col md={2}>
              <Form.Check
                type="switch"
                label="Uygulamada cevap versin"
                checked={!!config.enabled}
                onChange={(e) => setConfig({ ...config, enabled: e.target.checked })}
              />
            </Col>
            <Col md={4}>
              <Form.Label>Model adresi</Form.Label>
              <Form.Control
                value={config.baseUrl}
                onChange={(e) => setConfig({ ...config, baseUrl: e.target.value })}
              />
            </Col>
            <Col md={3}>
              <Form.Label>Model adı</Form.Label>
              <Form.Control
                value={config.model}
                onChange={(e) => setConfig({ ...config, model: e.target.value })}
              />
            </Col>
            <Col md={1}>
              <Form.Label>Gecikme</Form.Label>
              <Form.Control
                type="number"
                min="0"
                max="30"
                value={config.delaySeconds}
                onChange={(e) => setConfig({ ...config, delaySeconds: e.target.value })}
              />
            </Col>
            <Col md={2}>
              <Button disabled={saving} onClick={() => save(config)}>Bağlantıyı kaydet</Button>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      <Row>
        <Col lg={6}>
          <Card className="mb-3">
            <Card.Body>
              <h5>Komutlar</h5>
              <Form.Control
                as="textarea"
                rows={4}
                className="mb-2"
                placeholder="Yeni komutu yaz"
                value={draft}
                onChange={(e) => setDraft(e.target.value)}
              />
              <Button className="mb-3" disabled={saving || !draft.trim()} onClick={addRule}>Komutu ekle</Button>
              {config.rules.length === 0 && <div className="text-muted">Henüz komut yok.</div>}
              {config.rules.map((rule) => (
                <div key={rule.id} className="border rounded p-2 mb-2">
                  <div className="d-flex justify-content-between mb-2">
                    <Badge bg={rule.active ? "success" : "secondary"}>{rule.active ? "Açık" : "Kapalı"}</Badge>
                    <div>
                      <Button size="sm" variant="outline-secondary" className="me-2" onClick={() => save({ ...config, rules: config.rules.map((item) => item.id === rule.id ? { ...item, active: !item.active } : item) })}>
                        {rule.active ? "Kapat" : "Aç"}
                      </Button>
                      <Button size="sm" variant="outline-danger" onClick={() => removeRule(rule.id)}>Sil</Button>
                    </div>
                  </div>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    value={rule.text}
                    onChange={(e) => updateRule(rule.id, { text: e.target.value })}
                    onBlur={(e) => {
                      const rules = config.rules.map((item) => (
                        item.id === rule.id ? { ...item, text: e.target.value } : item
                      ));
                      save({ ...config, rules });
                    }}
                  />
                </div>
              ))}
            </Card.Body>
          </Card>
        </Col>
        <Col lg={6}>
          <Card>
            <Card.Body>
              <h5>Canlı deneme</h5>
              <Row className="g-2 mb-3">
                <Col><Form.Control value={name} onChange={(e) => setName(e.target.value)} placeholder="Ad" /></Col>
                <Col><Form.Control value={age} onChange={(e) => setAge(e.target.value)} placeholder="Yaş" /></Col>
                <Col><Form.Control value={manCity} onChange={(e) => setManCity(e.target.value)} placeholder="Erkeğin şehri" /></Col>
              </Row>
              <div style={{ minHeight: 280, maxHeight: 420, overflowY: "auto" }} className="border rounded p-2 mb-2 bg-light">
                {chat.length === 0 && <div className="text-muted">Kaydettiğin komutlarla burada konuş.</div>}
                {chat.map((item, index) => (
                  <div key={index} className={`mb-2 ${item.role === "user" ? "text-end" : ""}`}>
                    <span className={`d-inline-block px-2 py-1 rounded ${item.role === "user" ? "bg-primary text-white" : "bg-white border"}`}>
                      {item.content}
                    </span>
                  </div>
                ))}
                {asking && <Spinner size="sm" animation="border" />}
              </div>
              <div className="d-flex">
                <Form.Control
                  value={text}
                  placeholder="Mesaj yaz"
                  onChange={(e) => setText(e.target.value)}
                  onKeyDown={(e) => { if (e.key === "Enter" && !e.shiftKey) { e.preventDefault(); sendTest(); } }}
                />
                <Button className="ms-2" disabled={asking || !text.trim()} onClick={sendTest}>Gönder</Button>
                <Button className="ms-2" variant="outline-secondary" onClick={() => setChat([])}>Temizle</Button>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </div>
  );
}
